import React, { useCallback } from "react";
import { MAX_ZOOM, MIN_ZOOM } from "../../constants";
import { useTimelineZoom } from "../../context/use-timeline-zoom";
import {
  Button,
  Input,
  ZoomSliderWrapper,
  RangeContainer,
  RangeTrack,
} from "./styled";
import { getIcon } from "../../../../../../../utils/get-icon";

export const ZoomSlider: React.FC = () => {
  const { zoom, setZoom } = useTimelineZoom();

  const ZOOM_STEP = 0.5;

  const handleSliderChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const rawValue = parseInt(e.target.value, 10);
      const realValue = rawValue / 100;
      setZoom(realValue);
    },
    [setZoom]
  );

  const handleZoomOut = useCallback(() => {
    setZoom((prev) => Math.max(prev - ZOOM_STEP, MIN_ZOOM));
  }, [setZoom]);

  const handleZoomIn = useCallback(() => {
    setZoom((prev) => Math.min(prev + ZOOM_STEP, MAX_ZOOM));
  }, [setZoom]);

  return (
    <ZoomSliderWrapper>
      <Button onClick={handleZoomOut}>{getIcon("zoomOut")}</Button>
      <RangeContainer>
        <RangeTrack
          value={zoom * 100}
          min={MIN_ZOOM * 100}
          max={MAX_ZOOM * 100}
        />
        <Input
          value={zoom * 100}
          onChange={handleSliderChange}
          min={MIN_ZOOM * 100}
          max={MAX_ZOOM * 100}
          step={ZOOM_STEP * 10}
          type="range"
          title="Zoom"
        />
      </RangeContainer>
      <Button onClick={handleZoomIn}>{getIcon("zoomIn")}</Button>
    </ZoomSliderWrapper>
  );
};
